import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACTS } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-navy-950 text-slate-300">
    <div className="grain absolute inset-0" />
    <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
        <div>
          <Logo dark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Aukštos klasės įtempiamos lubos visoje Lietuvoje. Montavimas per 1 dieną, 10 metų garantija.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300">Navigacija</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["/", "Pagrindinis"],
              ["/paslaugos", "Paslaugos"],
              ["/galerija", "Galerija"],
              ["/kontaktai", "Kontaktai"],
              ["/admin", "Administratoriaus zona"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                  className="transition-colors duration-200 hover:text-white"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300">Kontaktai</h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-sky-400" />
              <a href={`tel:${CONTACTS.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="hover:text-white">
                {CONTACTS.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-sky-400" />
              <a href={`mailto:${CONTACTS.email}`} data-testid="footer-email" className="hover:text-white">
                {CONTACTS.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-sky-400" />
              <span>{CONTACTS.city} — dirbame visoje Lietuvoje</span>
            </li>
            <li className="flex items-center gap-3">
              <Clock className="h-4 w-4 text-sky-400" />
              <span>{CONTACTS.hours}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 sm:flex-row">
        <span>© 2026 ART Ceiling. Visos teisės saugomos.</span>
        <span>Sukurta su meile tobuloms erdvėms.</span>
      </div>
    </div>
  </footer>
);
